module.exports = __webpack_public_path__ + "static/process1-9eac739d8c2f9d4106e9fda6af6706be.jpeg";